import {Component, Inject} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from "@angular/material/dialog";
import {OrderComponent} from "../../order-manager/order/order.component";
import {AttachmentsService} from "../../../services-otc/attachments.service";
import { NavBarComponent } from 'src/app/nav-bar/nav-bar.component';

@Component({
    selector: 'app-remove-attachment',
    templateUrl: './remove-attachment.component.html',
    styleUrls: ['./remove-attachment.component.css'],
    standalone: false
})
export class RemoveAttachmentComponent {

  attachmentId = this.data.attachmentID;
  constructor(@Inject(MAT_DIALOG_DATA) public data: any,
              public dialogRef: MatDialogRef<OrderComponent>,
              private attachmentsService: AttachmentsService,
              public nav: NavBarComponent,
  ) {
  }
  cancelRemovingAttachment(){
    this.dialogRef.close();
  }
  deleteOrderAttachment(){
    this.nav.toggleLoading(true);
    this.attachmentsService.deleteAttachmentListItem(this.data.attachmentID).subscribe(() => {
      this.dialogRef.close();
      this.nav.toggleLoading(false);
    });
  }

}
